
import React, { Component } from 'react';

import Field from './Field';

import GiveUpButton from './GiveUpButton';

import './../../../../scss/App.scss';
import FooterLogo from '../../FooterLogo';

class Game extends Component {
	constructor(props){
		super(props);

		this.totalAnswers = this.props.totalAnswers;
		this.answersCompleted = [];

		this.giveUpTime = (window.config.giveUpTime * 1000);
		this.giveUpTimer = null;

		this.state = {
			fieldIsFocused : false,
			answersCompleted : [],
			revealingAnswersMode : false,
			showGiveUp : false,
			checkAnswer : null
		};

		this.handleCorrectAnswer = this.handleCorrectAnswer.bind(this);
		this.handleWrongAnswer = this.handleWrongAnswer.bind(this);
		this.handleFieldIsFocused = this.handleFieldIsFocused.bind(this);
		this.resetGiveUpTimer = this.resetGiveUpTimer.bind(this);
		this.updateAnswerHandler = this.updateAnswerHandler.bind(this);
		this.blurIn = this.blurIn.bind(this);
		this.blurOut = this.blurOut.bind(this);
	}

	componentDidMount(){

		window.TweenMax.set(this.refs.game, {"opacity":0});
		window.TweenMax.to(this.refs.game, .5, {"opacity":1, "filter":"blur(5px)"});


		if(this.props.questionSet !== null){
			this.resetGiveUpTimer();
		}
	}

	componentWillUnmount(){
		clearTimeout(this.giveUpTimer);
	}

	componentWillUpdate(nextProps, nextState){
		/*
		console.log("Game :: componentWillUpdate - this.props.roundIsStarted : ", this.props.roundIsStarted);
		console.log("Game :: componentWillUpdate - nextProps.roundIsStarted : ", nextProps.roundIsStarted);

		// if round starting
		if(this.props.roundIsStarted === false && nextProps.roundIsStarted === true){
			this.resetGiveUpTimer();
		}
		*/


		// if parent tells this to start revealing answers
		if(this.props.showAnswers === false && nextProps.showAnswers === true){
			this.setState({
				revealingAnswersMode : true
			});

			const _this = this;
			setTimeout(function(){
				_this.revealNextAnswer()
			}, 10);
		}
	}

	componentDidUpdate(prevProps, prevState){
		//console.log("Game :: componentDidUpdate");

		// blur the game area
		if(this.props.blurGame === true && prevProps.blurGame === false){
			//console.log("Game :: componentDidUpdate - blurOut");
			this.blurOut();
		}

		// unblur the game area
		if(this.props.blurGame === false && prevProps.blurGame === true){
			//console.log("Game :: componentDidUpdate - blurIn");
			this.blurIn();
		}
	}

	blurIn(){
		//console.log("Game :: blurIn - this.refs.game : ", this.refs.game);
		window.TweenMax.to(this.refs.game, .5, {"filter":"blur(0px)"});
	}

	blurOut(){
		//console.log("Game :: blurOut");
		window.TweenMax.to(this.refs.game, .5, {"filter":"blur(5px)"});
	}

	resetGiveUpTimer(){
		//console.log("Game :: resetGiveUpTimer");

		const _this = this;

		clearTimeout(this.giveUpTimer);

		this.giveUpTimer = setTimeout(function(){
			//console.log("Game :: resetGiveUpTimer - show give up button");
			_this.setState({
				showGiveUp : true
			});
		}, this.giveUpTime);
	}

	revealNextAnswer(){
		var unansweredFound = true;

		for(let i = 0; i < this.totalAnswers; i++){
			if(this.state.answersCompleted[i] !== true){
				var newAnswersCompleted = [...this.state.answersCompleted];
				newAnswersCompleted[i] = true;

				this.setState({
					answersCompleted : newAnswersCompleted
				});

				break;
			}
			else if(i === (this.totalAnswers - 1)){
				unansweredFound = false;
			}
		}

		//

		const _this = this;

		if(unansweredFound){
			setTimeout(function(){
				_this.revealNextAnswer();
			}, 1000);
		}
		else {
			_this.props.handleAnswerRevealComplete();
		}
	}

	handleCorrectAnswer(key){
		//console.log("Game :: handleCorrectAnswer");

		const _this = this;
		const _key = key;

		window.TweenMax.set(this.refs.correctAnswerCue, {"opacity": .8});
		window.TweenMax.to(this.refs.correctAnswerCue, 1.3, {"opacity": 0, onComplete:function(){

		}});

		// update completion
		var newAnswersCompleted = [..._this.state.answersCompleted];
		newAnswersCompleted[_key] = true;

		_this.setState({
			answersCompleted : newAnswersCompleted
		});

		// update parent
		_this.props.handleCorrectAnswer();
	}

	handleWrongAnswer(){
		window.TweenMax.set(this.refs.wrongAnswerCue, {"opacity": .8});
		window.TweenMax.to(this.refs.wrongAnswerCue, 1.3, {"opacity": 0});
	}

	handleFieldIsFocused(boolean){
		this.setState({
			fieldIsFocused : boolean
		});
	}

	updateAnswerHandler(answer){
		this.setState({
			checkAnswer : answer
		});
	}

	renderAnswers(){
		//console.log("GamePage:: renderAnswers");

		const _this = this;

		if(this.props.questionSet !== null){
			if(this.props.questionSet.answers){
				return this.props.questionSet.answers.map(function(answer, i){
					const shouldShowAnswer = _this.state.answersCompleted[i];
					return <Field key={i} answer={answer} handleCorrectAnswer={() => _this.handleCorrectAnswer(i)} handleWrongAnswer={_this.handleWrongAnswer} handleFieldIsFocused={_this.handleFieldIsFocused} showAnswers={shouldShowAnswer} checkAnswer={_this.state.checkAnswer} updateAnswerHandler={_this.updateAnswerHandler} revealingAnswersMode={_this.state.revealingAnswersMode} />;
				});
			}
			else {
				//console.log("Game::renderAnswers - questionSet answers is undefined");
			}
		}
		else {
			//console.log("Game::renderAnswers - questionSet is null");
		}
	}

	renderInstructionsHint(){
		if(!this.state.revealingAnswersMode){
			if(this.state.fieldIsFocused){
				return(
					<div className="hint">(fill-out the answer)</div>
				)
			}
			else{
				return(
					<div className="hint">(choose a blanked-out word to start typing)</div>
				)
			}
		}
	}

	render(){

		const question = (this.props.questionSet !== null) ? this.props.questionSet.question : "";

		const answersReadOnly = (this.props.showAnswers) ? " readOnly" : "";

		return(
			<div id="game" ref="game">
				<div className="questionBox">{question}</div>
				<div className={"answers_wrapper" + answersReadOnly} onClick={() => this.resetGiveUpTimer()}>
					{this.renderAnswers()}
				</div>
				{this.renderInstructionsHint()}
				<GiveUpButton show={(this.state.showGiveUp && this.props.roundIsStarted)} handleGiveUp={() => this.props.handleGiveUp()} onMouseOver={() => window.sounds.buttonHover.play()} />
				<div className="correctAnswerCue" ref="correctAnswerCue"></div>
				<div className="wrongAnswerCue" ref="wrongAnswerCue"></div>
				<FooterLogo />
			</div>
		);
	}

}

export default Game;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/game/Game.js